import { Link } from 'react-router-dom';
import { quickChannels } from '@/mocks/siteData';
import SectionHeading from '@/components/base/SectionHeading';

export default function QuickChannels() {
  return (
    <section id="channels" className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <SectionHeading
              kicker="Official Channels"
              title="官方联系渠道速览"
              description="以下三条通道均由平台直接维护，适合不同场景下的联络需求。通道之间互不关联，你可以只选其中一条。"
            />
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap shrink-0"
            >
              查看完整联系方式
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="mt-10 md:mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
            {quickChannels.map((channel) => (
              <article
                key={channel.title}
                className="group relative bg-background-50 border border-foreground-950/10 rounded-lg p-6 md:p-7 hover:border-primary-300 transition-colors"
              >
                <div className="flex items-start justify-between gap-4">
                  <span className="w-12 h-12 flex items-center justify-center rounded-md bg-foreground-950 text-background-50 group-hover:bg-primary-500 transition-colors">
                    <i className={`${channel.icon} text-xl`}></i>
                  </span>
                  <span className="font-mono text-[10px] tracking-[0.16em] uppercase px-2.5 py-1 rounded-full bg-accent-100 text-accent-900">
                    {channel.tag}
                  </span>
                </div>

                <h3 className="mt-6 font-heading text-lg font-bold text-foreground-950">
                  {channel.title}
                </h3>
                <p className="mt-3 font-mono text-sm text-primary-600 break-all">{channel.value}</p>
                <p className="mt-4 text-sm leading-relaxed text-foreground-600">{channel.desc}</p>
              </article>
            ))}
          </div>

          <p className="mt-8 flex items-start gap-3 text-xs md:text-sm text-foreground-500 leading-relaxed">
            <i className="ri-error-warning-line text-base text-primary-500 mt-0.5"></i>
            除上述渠道外，平台不会通过其他域名或私人账号索要身份信息、验证码与任何费用，收到此类联络请先来函核实。
          </p>
        </div>
      </div>
    </section>
  );
}